import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import "./hand_volume.css";
import Button from "../../_components/button/Button";
import SlideOver from "../../_components/slide_over/SlideOver";

const HandVolume = () => {
  return (
    <section className="z-50 relative" id="gaming">
      <div
        className="bg-black py-12 lg:py-12 bg-no-repeat bg-cover	bg-bottom overflow-y-hidden"
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/avm90-volume-control-bg-only_.jpg" +
            ")",
        }}
      >
        <div className="max-w-7xl mx-auto text-white  md:text-gray-900">
          <h4 className="xl:w-2/5 lg:w-full text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug">
            Balance, in Perfect Harmony
          </h4>
          <div class="lg:flex gap-5 ">
            <div className="w-full xl:w-2/5 lg:w-2/3">
              <p className="text-white mb-16 text-xl font-light mt-10 lg:text-left text-center">
                It's not about a single component, single feature or piece of
                software; it is about the totality of our design—everything
                working together in perfect harmony to deliver a performance
                that genuinely transcends the listening experience.
              </p>
            </div>
            <div className="w-full py-10 md:py-0 xl:w-3/5 lg:w-2/3 ">
              <video
                id="video"
                width="100%"
                autoPlay
                loop
                muted
                playsInline
                className="relative lg:absolute lg:right-0 lg:w-1/2 bottom-0 xl:h-full w-full sm:w-full hidden md:block"
              >
                <source
                  src="https://cdn.pmlsound.com/anthem/avm90/videos/hand_volume_new.webm"
                  type="video/webm"
                />
                <source
                  src="https://cdn.pmlsound.com/anthem/avm90/videos/avm-90-volume-web_.mp4"
                  type="video/mp4"
                />
              </video>
              <img
                src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-volume-control.png"
                alt="web ui"
                className="block md:hidden lg:hidden -mb-12"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HandVolume;
